import { render, staticRenderFns } from "./passwordAndLogin.vue?vue&type=template&id=6c0d2f6a&lang=pug"
import script from "./passwordAndLogin.vue?vue&type=script&lang=js"
export * from "./passwordAndLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports